// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1erY_","selects":"Documents_selects__GEw2e"};